import Opportunity from 'opportunities/Opportunity'
import OpportunityStore, {
  ListOpportunitiesQuery,
  PickupResult,
} from 'opportunities/OpportunityStore'
import { OpportunitiesPort } from 'opportunities/ports'
import { OpportunityEvent } from 'opportunities/opportunity-events'
import { CursorPaged } from 'types/definitions'
import Consultation from 'jobs/consultations/Consultation'
import ConsultationStore from 'jobs/consultations/ConsultationStore'
import { TimeRange } from 'jobs/TimeRange'
import { Observable } from 'rxjs'

export default class OpportunitiesAdapter implements OpportunitiesPort {
  events$: Observable<OpportunityEvent>

  constructor(
    private opportunityStore: OpportunityStore,
    private consultationStore: ConsultationStore,
  ) {
    this.events$ = this.opportunityStore.events$
  }

  query(query: ListOpportunitiesQuery): Promise<CursorPaged<Opportunity>> {
    return this.opportunityStore.listOpportunities(query)
  }

  isOpportunityAvailable(opportunity: Opportunity): boolean {
    return Boolean(this.opportunityStore.opportunities.get(opportunity.id))
  }

  pickup(opportunity: Opportunity): Promise<PickupResult> {
    return this.opportunityStore.pickup(opportunity)
  }

  async applyForOpportunity(opportunity: Opportunity): Promise<void> {
    return this.opportunityStore.applyForOpportunity(opportunity)
  }

  probeCanViewOpportunities(): Promise<boolean> {
    return this.opportunityStore.probeCanViewOpportunities()
  }

  getOpportunity(id: string): Promise<Opportunity> {
    return this.opportunityStore.getOpportunity(id)
  }

  fetchBookedConsultations(): Promise<Consultation[]> {
    return this.consultationStore.fetchBookedConsultations()
  }

  pickupConsultation(
    id: string,
    bookedTime?: TimeRange,
  ): Promise<PickupResult> {
    return this.consultationStore.pickupConsultationJob(id, bookedTime)
  }

  withdrawApplication(opportunity: Opportunity) {
    return this.opportunityStore.withdrawApplication(opportunity)
  }
}
